import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MapPinIcon, CalendarIcon, ZapIcon, TrendingUpIcon, BarChart3Icon, UsersIcon, MessageSquareIcon, PhoneIcon, GlobeIcon, CheckCircleIcon, SearchIcon } from 'lucide-react';
import { ScrollReveal } from '../../components/ScrollReveal';
import { SEOHead } from '../../components/SEOHead';
const faqs = [{
  question: 'How did Viridia help TFP Landscaping get more leads?',
  answer: 'We implemented our Business Essentials package, which includes GEO-tuned Yelp Ads and an AI-powered Request a Quote (RAQ) system. By responding instantly to inquiries instead of waiting 4+ hours, TFP was able to capture leads before competitors could.'
}, {
  question: 'What results did TFP Landscaping see in 30 days?',
  answer: 'In just 30 days, TFP Landscaping saw a 284% increase in leads, totaling 242 Yelp leads. They achieved a 39.95% close rate on those leads, with 28 estimates booked end-to-end entirely by the AI system.'
}];
export function TfpLandscapingPage() {
  return <div className="bg-viridia-black min-h-screen pt-24" data-id="element-1408" data-mp="1snnorm6dl8bb">
      <SEOHead title="TFP Landscaping Case Study | 284% More Leads | Viridia Analytics" description="See how TFP Landscaping used Viridia Analytics' Business Essentials package to get 242 Yelp leads, 28 AI-booked estimates, and a 39.95% close rate in 30 days." canonical="/case-studies/tfp-landscaping" keywords="landscaping marketing case study, Yelp ads for landscapers, AI lead conversion, TFP Landscaping" faq={faqs} data-id="element-1409" data-mp="1sp8i58gyel7l" />

      <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-1410" data-mp="2qa4jqkrmz9tw">
        <ScrollReveal data-id="element-1411" data-mp="2lbjiqj4k8m4e">
          <div className="mb-6" data-id="element-1412" data-mp="2ld4e2ayp893b">
            <Link to="/case-studies" className="inline-flex items-center text-gray-400 hover:text-white transition-colors text-sm font-medium" data-id="element-1413" data-mp="2la004lvflyzg">
              <ArrowRightIcon className="w-4 h-4 mr-2 rotate-180" data-id="element-1414" data-mp="qzmpckmk566p" />
              Back to Case Studies
            </Link>
          </div>

          <div className="bg-viridia-surface border border-gray-800 rounded-2xl overflow-hidden shadow-2xl" data-id="element-1415" data-mp="1knst1uhlkc4q">
            {/* Header / Snapshot */}
            <div className="bg-gray-900 p-8 lg:p-12 relative overflow-hidden border-b border-gray-800" data-id="element-1416" data-mp="1pm43a6bt0onh">
              <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500/10 rounded-full blur-[100px]" data-id="element-1417" data-mp="1unjnjw65qr4t"></div>
              <div className="relative z-10" data-id="element-1418" data-mp="1zkt9v2y92mof">
                <div className="inline-flex items-center px-3 py-1 rounded-full bg-blue-500/10 text-blue-400 text-xs font-bold tracking-wide uppercase mb-6 border border-blue-500/20" data-id="element-1419" data-mp="23m50nbsv1dy7">
                  Landscaping Success Story
                </div>
                <h1 className="text-4xl lg:text-5xl font-bold text-white mb-8 leading-tight max-w-4xl" data-id="element-1420" data-mp="2dbokoksb7dun">
                  TFP Landscaping: 284% More Leads and Instant Responses With
                  Viridia's Business Essentials Package
                </h1>

                {/* Snapshot Pills */}
                <div className="flex flex-wrap gap-3 mb-10" data-id="element-1421" data-mp="bolp960u7jcb">
                  <div className="inline-flex items-center px-3 py-1.5 rounded-lg bg-viridia-black border border-gray-700 text-gray-300 text-sm" data-id="element-1422" data-mp="6nxy8kclz2i3">
                    <MapPinIcon className="w-4 h-4 mr-2 text-blue-500" data-id="element-1423" data-mp="1r7arbyh54mn" />
                    Phoenix Landscaper (18 yrs in business)
                  </div>
                  <div className="inline-flex items-center px-3 py-1.5 rounded-lg bg-viridia-black border border-gray-700 text-gray-300 text-sm" data-id="element-1424" data-mp="ucqnjxyq6c3q">
                    <ZapIcon className="w-4 h-4 mr-2 text-blue-500" data-id="element-1425" data-mp="pgs32lgipe8l" />
                    Business Essentials Package
                  </div>
                  <div className="inline-flex items-center px-3 py-1.5 rounded-lg bg-viridia-black border border-gray-700 text-gray-300 text-sm" data-id="element-1426" data-mp="fpnqtti887hg">
                    <CalendarIcon className="w-4 h-4 mr-2 text-blue-500" data-id="element-1427" data-mp="1d5kwob9o3a01" />
                    Client since July 2025
                  </div>
                </div>

                {/* Hero Stats Grid */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6" data-id="element-1428" data-mp="sxmmo2q83wqj">
                  <div className="bg-viridia-black/50 p-6 rounded-xl border border-gray-800" data-id="element-1429" data-mp="xw7no4daukg1">
                    <p className="text-3xl sm:text-4xl font-bold text-blue-500 mb-2" data-id="element-1430" data-mp="iyx2g3auu074">
                      284%
                    </p>
                    <p className="text-white font-medium text-sm" data-id="element-1431" data-mp="1bm1cwnspv6qa">
                      Lead Increase
                    </p>
                  </div>
                  <div className="bg-viridia-black/50 p-6 rounded-xl border border-gray-800" data-id="element-1432" data-mp="1gjt41fljeotf">
                    <p className="text-3xl sm:text-4xl font-bold text-blue-500 mb-2" data-id="element-1433" data-mp="11v6sloz16h7h">
                      242
                    </p>
                    <p className="text-white font-medium text-sm" data-id="element-1434" data-mp="16t86lvhlnqc3">
                      Total Leads
                    </p>
                  </div>
                  <div className="bg-viridia-black/50 p-6 rounded-xl border border-gray-800" data-id="element-1435" data-mp="1zbvo70xe0n8f">
                    <p className="text-3xl sm:text-4xl font-bold text-blue-500 mb-2" data-id="element-1436" data-mp="3k1hne7vculu2">
                      39.95%
                    </p>
                    <p className="text-white font-medium text-sm" data-id="element-1437" data-mp="3f2ent2y597th">Close Rate</p>
                  </div>
                  <div className="bg-viridia-black/50 p-6 rounded-xl border border-gray-800" data-id="element-1438" data-mp="3tr13x6vli3lr">
                    <p className="text-3xl sm:text-4xl font-bold text-blue-500 mb-2" data-id="element-1439" data-mp="3ot9au9j7sbfz">
                      28
                    </p>
                    <p className="text-white font-medium text-sm" data-id="element-1440" data-mp="2w425orp98nlr">
                      AI-Booked Estimates
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Challenge / Solution */}
            <div className="p-8 lg:p-12 bg-viridia-black border-b border-gray-800" data-id="element-1441" data-mp="360ont8q750k3">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-1442" data-mp="pckwdaznlbfu">
                <div data-id="element-1443" data-mp="lck86ymr5lvl">
                  <div className="w-12 h-12 rounded-xl bg-red-500/10 flex items-center justify-center mb-6" data-id="element-1444" data-mp="lb904mm9xryo">
                    <TrendingUpIcon className="w-6 h-6 text-red-500" data-id="element-1445" data-mp="3e5zfvd7n2e12" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-1446" data-mp="3j4aus2csjeq5">
                    The Challenge
                  </h3>
                  <p className="text-gray-400 leading-relaxed" data-id="element-1447" data-mp="3o2kkvyjnrp4w">
                    TFP Landscaping is a Phoenix-based operation with 18 years
                    in business. With one owner running multiple crews and no
                    office staff, their average response time was 4+ hours. Yelp
                    ad spend was being wasted because leads went cold before
                    anyone could reply.
                  </p>
                </div>
                <div data-id="element-1448" data-mp="398g0ub349x82">
                  <div className="w-12 h-12 rounded-xl bg-blue-500/10 flex items-center justify-center mb-6" data-id="element-1449" data-mp="398pj1chx7037">
                    <BarChart3Icon className="w-6 h-6 text-blue-500" data-id="element-1450" data-mp="2cnfhstfm7okr" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-1451" data-mp="2gp0r64sxxkq7">
                    What Viridia Implemented
                  </h3>
                  <p className="text-gray-400 leading-relaxed" data-id="element-1452" data-mp="248re27b24vd7">
                    We deployed the Business Essentials package - Yelp Ads
                    management with GEO tuning, an AI-powered Request a Quote
                    (RAQ) system for instant response, and automated lead
                    handling so every inquiry gets answered in seconds, even
                    outside business hours.
                  </p>
                </div>
              </div>
            </div>

            {/* 30-Day Performance Breakdown */}
            <div className="p-8 lg:p-12 bg-viridia-surface border-b border-gray-800" data-id="element-1453" data-mp="1gjgid48kdr5x">
              <h3 className="text-2xl font-bold text-white mb-8" data-id="element-1454" data-mp="1cid60rpq6d9g">
                30-Day Metrics
              </h3>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-1455" data-mp="17hpf061hxwf8">
                <div className="space-y-6" data-id="element-1456" data-mp="12iw1weq4g7fl">
                  <div className="bg-viridia-black p-6 rounded-xl border border-gray-800" data-id="element-1457" data-mp="12l8ox6aql7zi">
                    <div className="flex justify-between items-center mb-2" data-id="element-1458" data-mp="2qgmyki5g1jhc">
                      <span className="text-gray-400" data-id="element-1459" data-mp="2vdna38l2befu">Impressions</span>
                      <span className="text-white font-bold" data-id="element-1460" data-mp="2hfoygay4lw41">36.4k</span>
                    </div>
                    <div className="w-full bg-gray-800 rounded-full h-2 mb-2" data-id="element-1461" data-mp="2mdqmlaaeslmd">
                      <div className="bg-blue-500 h-2 rounded-full" style={{
                      width: '70%'
                    }} data-id="element-1462" data-mp="27pcae8r3rkt5"></div>
                    </div>
                    <p className="text-xs text-gray-500" data-id="element-1463" data-mp="1ypyzdbnbyo6b">
                      25.5k (70%) from Yelp Ads
                    </p>
                  </div>
                  <div className="bg-viridia-black p-6 rounded-xl border border-gray-800" data-id="element-1464" data-mp="1oqrp4xbw79nf">
                    <div className="flex justify-between items-center mb-2" data-id="element-1465" data-mp="1tpl30qv3d2o4">
                      <span className="text-gray-400" data-id="element-1466" data-mp="1trnr35coolq7">Page Visits</span>
                      <span className="text-white font-bold" data-id="element-1467" data-mp="1a4km9t87tcph">376</span>
                    </div>
                    <div className="w-full bg-gray-800 rounded-full h-2 mb-2" data-id="element-1468" data-mp="155zumi7141cn">
                      <div className="bg-blue-500 h-2 rounded-full" style={{
                      width: '77%'
                    }} data-id="element-1469" data-mp="1k28rxe7d04mf"></div>
                    </div>
                    <p className="text-xs text-gray-500" data-id="element-1470" data-mp="1t0kff7cximan">
                      288 (77%) from Yelp Ads
                    </p>
                  </div>
                  <div className="bg-viridia-black p-6 rounded-xl border border-gray-800" data-id="element-1471" data-mp="22sq52afpkrmo">
                    <div className="flex justify-between items-center mb-2" data-id="element-1472" data-mp="1xsu30gqkna9r">
                      <span className="text-gray-400" data-id="element-1473" data-mp="2bt4unlzpgsvz">Total Leads</span>
                      <span className="text-white font-bold" data-id="element-1474" data-mp="2btek98gu8y15">242</span>
                    </div>
                    <div className="w-full bg-gray-800 rounded-full h-2 mb-2" data-id="element-1475" data-mp="27te5tntqomu3">
                      <div className="bg-blue-500 h-2 rounded-full" style={{
                      width: '74%'
                    }} data-id="element-1476" data-mp="3s8bboe4u3ku3"></div>
                    </div>
                    <p className="text-xs text-gray-500" data-id="element-1477" data-mp="3dinbjg8e2s7y">
                      179 (74%) from Yelp Ads
                    </p>
                  </div>
                </div>

                <div data-id="element-1478" data-mp="f087yr0rvneg">
                  <h4 className="text-lg font-semibold text-white mb-4" data-id="element-1479" data-mp="a1x0gmxy9oze">
                    Lead Breakdown
                  </h4>
                  <div className="bg-viridia-black rounded-xl border border-gray-800 overflow-hidden" data-id="element-1480" data-mp="522aclm013fe">
                    <table className="w-full text-left text-sm" data-id="element-1481" data-mp="1204s1d57puu">
                      <thead className="bg-gray-900 border-b border-gray-800" data-id="element-1482" data-mp="2pt2s6w8bpsy5">
                        <tr data-id="element-1483" data-mp="2pqydrkcstbjm">
                          <th className="p-4 text-gray-400 font-medium" data-id="element-1484" data-mp="2lrpiuc60v7mh">
                            Lead Type
                          </th>
                          <th className="p-4 text-gray-400 font-medium" data-id="element-1485" data-mp="11aq7cuh3f9h6">
                            Count
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-800" data-id="element-1486" data-mp="1a9bkga3spwak">
                        <tr data-id="element-1487" data-mp="1f1d5akf14vc7">
                          <td className="p-4 text-white flex items-center" data-id="element-1488" data-mp="1f1lg86rldqkr">
                            <MessageSquareIcon className="w-4 h-4 mr-2 text-blue-500" data-id="element-1489" data-mp="1k0ppsyifhqbm" />{' '}
                            Messages
                          </td>
                          <td className="p-4 text-white font-bold" data-id="element-1490" data-mp="1p0u9exemv162">123</td>
                        </tr>
                        <tr data-id="element-1491" data-mp="1syrubo1df13n">
                          <td className="p-4 text-white flex items-center" data-id="element-1492" data-mp="1y07frh7gn9mk">
                            <PhoneIcon className="w-4 h-4 mr-2 text-blue-500" data-id="element-1493" data-mp="3urzdj8k3u2ut" />{' '}
                            Calls
                          </td>
                          <td className="p-4 text-white font-bold" data-id="element-1494" data-mp="3mg1u5i3m3lb">53</td>
                        </tr>
                        <tr data-id="element-1495" data-mp="16x3y1c4eniq5">
                          <td className="p-4 text-white flex items-center" data-id="element-1496" data-mp="16yf1tbxuoqh9">
                            <GlobeIcon className="w-4 h-4 mr-2 text-blue-500" data-id="element-1497" data-mp="11z26s3wtsd3l" />{' '}
                            Website Visits
                          </td>
                          <td className="p-4 text-white font-bold" data-id="element-1498" data-mp="1axnra4luy270">41</td>
                        </tr>
                        <tr data-id="element-1499" data-mp="1pumy3q8vxr0f">
                          <td className="p-4 text-white flex items-center" data-id="element-1500" data-mp="1ptvcn89059nv">
                            <CheckCircleIcon className="w-4 h-4 mr-2 text-blue-500" data-id="element-1501" data-mp="1kvac17pu8nyw" />{' '}
                            Other Leads
                          </td>
                          <td className="p-4 text-white font-bold" data-id="element-1502" data-mp="1um4yac333nkc">25</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* AI Bookings & Close Rate */}
            <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-1503" data-mp="23kqgg64n90kl">
              <div className="p-8 lg:p-12 bg-viridia-black border-r border-gray-800" data-id="element-1504" data-mp="2n9xywrwtcmys">
                <div className="w-12 h-12 rounded-xl bg-blue-500/10 flex items-center justify-center mb-6" data-id="element-1505" data-mp="2s7zev3yy0661">
                  <ZapIcon className="w-6 h-6 text-blue-500" data-id="element-1506" data-mp="2d9fadjub0iaj" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-1507" data-mp="2i8qpkof0vfq0">
                  AI-Booked Estimates
                </h3>
                <p className="text-gray-400 leading-relaxed mb-6" data-id="element-1508" data-mp="24gkbr8zcdktq">
                  28 estimates were booked end-to-end by AI directly inside Yelp
                  RAQ. By replacing a 4+ hour lag with an instant response, the
                  AI captured homeowners while they were still actively looking
                  to hire.
                </p>
                <div className="inline-flex items-center px-4 py-2 rounded-lg bg-viridia-surface border border-gray-800 text-white font-medium" data-id="element-1509" data-mp="1ljj0x7j3wqhv">
                  Response Time:{' '}
                  <span className="text-blue-500 ml-2" data-id="element-1510" data-mp="1ihod72pohlok">
                    From 4+ hours to Instant
                  </span>
                </div>
              </div>
              <div className="p-8 lg:p-12 bg-viridia-black" data-id="element-1511" data-mp="1djd4ivb4dh7x">
                <div className="w-12 h-12 rounded-xl bg-blue-500/10 flex items-center justify-center mb-6" data-id="element-1512" data-mp="18r37kvbl7gw5">
                  <UsersIcon className="w-6 h-6 text-blue-500" data-id="element-1513" data-mp="13rqlwdwgcfv5" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-1514" data-mp="zrgfx18ntpga">
                  Close Rate
                </h3>
                <p className="text-gray-400 leading-relaxed mb-6" data-id="element-1515" data-mp="ur29fnmpinkd">
                  Because leads were engaged instantly and qualified
                  automatically, TFP Landscaping reported a 39.95% close rate on
                  the estimates that were booked.
                </p>
                <div className="inline-flex items-center px-4 py-2 rounded-lg bg-viridia-surface border border-gray-800 text-white font-medium" data-id="element-1516" data-mp="2k7a059xe86hj">
                  Client-Reported Close Rate:{' '}
                  <span className="text-blue-500 ml-2" data-id="element-1517" data-mp="2npqwrzxtji5k">39.95%</span>
                </div>
              </div>
            </div>

            {/* Owning the Local Map & 12-Month Impact */}
            <div className="grid grid-cols-1 lg:grid-cols-2 border-t border-gray-800" data-id="element-1518" data-mp="2wgr8iqxy8dfn">
              <div className="p-8 lg:p-12 bg-viridia-surface border-r border-gray-800" data-id="element-1519" data-mp="31g2se8tm3z1g">
                <div className="w-12 h-12 rounded-xl bg-blue-500/10 flex items-center justify-center mb-6" data-id="element-1520" data-mp="24q38ji80he3k">
                  <MapPinIcon className="w-6 h-6 text-blue-500" data-id="element-1521" data-mp="28rf1nxq3ghgi" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-1522" data-mp="28thyp1pnzauq">
                  GEO & Local Visibility
                </h3>
                <ul className="space-y-4 mb-8" data-id="element-1523" data-mp="2iqe3awcfzcu0">
                  <li className="flex items-start" data-id="element-1524" data-mp="2ir5uluz0aoeh">
                    <CheckCircleIcon className="w-5 h-5 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-1525" data-mp="3p6q2n0r030r6" />
                    <span className="text-gray-300" data-id="element-1526" data-mp="3u48f31487y3x">
                      TFP earned more page views than similar landscaping
                      businesses.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-1527" data-mp="2zgrfolqfcw4c">
                    <CheckCircleIcon className="w-5 h-5 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-1528" data-mp="2zk5ks1qh3jfh" />
                    <span className="text-gray-300" data-id="element-1529" data-mp="3ecpeycvnagks">
                      GEO-tuned campaigns targeted specific high-value
                      neighborhoods.
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-1530" data-mp="2grb9pivz0bgj">
                    <CheckCircleIcon className="w-5 h-5 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-1531" data-mp="2gsut3icxb2mj" />
                    <span className="text-gray-300" data-id="element-1532" data-mp="2vhqz79vf65ki">
                      Successfully competing with high-volume brands like Moon
                      Valley Nurseries.
                    </span>
                  </li>
                </ul>
              </div>

              <div className="p-8 lg:p-12 bg-viridia-surface" data-id="element-1533" data-mp="1y1btlli3y6p9">
                <div className="w-12 h-12 rounded-xl bg-blue-500/10 flex items-center justify-center mb-6" data-id="element-1534" data-mp="1xyzcfak6c0d9">
                  <SearchIcon className="w-6 h-6 text-blue-500" data-id="element-1535" data-mp="i9hmb8ksbu7t" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-1536" data-mp="ibkjcckcunm1">
                  12-Month Impact
                </h3>
                <p className="text-gray-300 mb-6" data-id="element-1537" data-mp="8jev9dx84qc4">
                  Over the last 12 months, Yelp Ads have generated an additional{' '}
                  <strong className="text-white" data-id="element-1538" data-mp="wakaprz95glw">582 leads</strong> for TFP
                  Landscaping.
                </p>
                <div data-id="element-1539" data-mp="117kflzkd8dbf">
                  <p className="text-sm text-gray-400 mb-3 uppercase tracking-wider font-semibold" data-id="element-1540" data-mp="n8ktaykbsaif">
                    Trending Searches Captured:
                  </p>
                  <div className="flex flex-wrap gap-2" data-id="element-1541" data-mp="r8ctamvnl8c6">
                    <span className="px-3 py-1 bg-viridia-black border border-gray-700 rounded-full text-xs text-gray-300" data-id="element-1542" data-mp="37yjxqy25w1ga">
                      Fountain Repair{' '}
                      <span className="text-blue-500 ml-1" data-id="element-1543" data-mp="7ikf8a4vjgvl">+87%</span>
                    </span>
                    <span className="px-3 py-1 bg-viridia-black border border-gray-700 rounded-full text-xs text-gray-300" data-id="element-1544" data-mp="7g7q9d0p8691">
                      Turf Installation{' '}
                      <span className="text-blue-500 ml-1" data-id="element-1545" data-mp="3unthfqjvq7lh">+50%</span>
                    </span>
                    <span className="px-3 py-1 bg-viridia-black border border-gray-700 rounded-full text-xs text-gray-300" data-id="element-1546" data-mp="3pprrqmry7a11">
                      Irrigation{' '}
                      <span className="text-blue-500 ml-1" data-id="element-1547" data-mp="m6yiuna479d7">+50%</span>
                    </span>
                    <span className="px-3 py-1 bg-viridia-black border border-gray-700 rounded-full text-xs text-gray-300" data-id="element-1548" data-mp="hg88evmu0gbn">
                      Landscaping{' '}
                      <span className="text-blue-500 ml-1" data-id="element-1549" data-mp="cfucud2f2yui">+40%</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Testimonial */}
            <div className="p-8 lg:p-12 bg-viridia-black border-t border-gray-800 text-center relative" data-id="element-1550" data-mp="1chgzsk8tzmr7">
              <div className="text-blue-500 text-6xl absolute top-4 left-1/2 -translate-x-1/2 opacity-10 font-serif leading-none" data-id="element-1551" data-mp="1hgk2vz593iwj">
                "
              </div>
              <p className="text-xl md:text-2xl text-white italic relative z-10 max-w-3xl mx-auto mb-6 leading-relaxed" data-id="element-1552" data-mp="1meddr5hi1135">
                I'm getting more jobs with the same ad spend. The auto response
                system is booking me almost 10 new estimates per week, and
                almost half of them become clients.
              </p>
              <p className="text-blue-500 font-bold uppercase tracking-wider text-sm" data-id="element-1553" data-mp="255mmvdncxnu7">
                Owner, TFP Landscaping - Phoenix, AZ
              </p>
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.2} data-id="element-1554" data-mp="2e7m5ubhxn1zs">
          <div className="mt-12 text-center" data-id="element-1555" data-mp="2e8nqn7or32up">
            <h3 className="text-2xl font-bold text-white mb-6" data-id="element-1556" data-mp="2j5e7vycak4hp">
              Want to see what's leaking leads in your pipeline?
            </h3>
            <Link to="/contact" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold text-viridia-black bg-white rounded-lg hover:bg-gray-200 transition-all duration-300" data-id="element-1557" data-mp="3k4dvsh7xeml8">
              Book a Strategy Call
              <ArrowRightIcon className="ml-2 w-5 h-5" data-id="element-1558" data-mp="1xzmivklr0t6" />
            </Link>
          </div>
        </ScrollReveal>
      </section>
    </div>;
}